import gql from 'graphql-tag'

export const FOOTER_WIDGET = gql`
  query footerWidget {
    footer {
      widgets {
        id
        __typename
        ... on GlobalFooterAccreditationIcons {
          id
          image1
          image1Alt
          image1Href
          subtitle1
          image2
          image2Href
          Image2Alt
          subtitle2
          image3
          Image3Href
          Image3Alt
          subtitle3
        }
      }
    }
  }
`
